import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import useHttp from "../../../hook/use-http";
import moment from "moment";
import { ThreeCircles } from "react-loader-spinner";
import { Chart } from "react-google-charts";
import NoData_Coral from "./NoData_Coral";
import ChartLoader_Coral from "./ChartLoader_Coral";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitialstates_coral";
import BuketsTable from "./BuketsTable_Coral";
import * as $ from "jquery";
import { Scatter } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
} from "chart.js";

// Register the required components for the chart
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend
);

function RpmVsThrottle_Coral({ apiend, gloablfilter, title }) {
  const [greater_110, setGreater_110] = useState([]);
  const [lesser_110, setLesser_110] = useState([]);
  const [lesser_110_trendline, setLesser_110_trendline] = useState([]);
  const [greater_110_trendline, setGreater_110_trendline] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  let modal_title = title;

  const appyData = (data) => {
    setGreater_110(data.scatterData1);
    setLesser_110(data.scatterData2);
    setGreater_110_trendline(data.trendlineData1);
    setLesser_110_trendline(data.trendlineData2);
  };

  useEffect(() => {
    setGreater_110([]);
    setLesser_110([]);
    fetchData(
      {
        url: API_URL_MAIN + "coral_drive_analysis/" + apiend,
        body: { filterdata: gloablfilter },
      },
      appyData
    );
  }, [gloablfilter]);

  const data = {
    datasets: [
      {
        label: "Trendline",
        data: greater_110_trendline,
        borderColor: "#32879c",
        borderWidth: 2.5,
        zIndex: 99999,
        fill: false,
        showLine: true, // Draw the trendline
        pointRadius: 0, // Hide points for the trendline
      },
      {
        label: "Trendline",
        data: lesser_110_trendline,
        borderColor: "#FFA650",
        borderWidth: 2.5,
        fill: false,
        zIndex: 99999,
        showLine: true, // Draw the trendline
        pointRadius: 0, // Hide points for the trendline
      },
      {
        label: "High Range",
        // data: scatterData,
        data: greater_110,
        // backgroundColor: "#32879c",
        backgroundColor: "rgba(52, 131, 147, 0.6)",
        borderColor: "rgba(197, 198, 199, 0.5)",
        showLine: false, // No line for the scatter dataset
      },
      {
        label: "Low Range",
        // data: scatterData2,
        data: lesser_110,
        // backgroundColor: "#FFA650",
        backgroundColor: "rgba(255, 166, 80, 0.6)",
        borderColor: "rgba(197, 198, 199, 0.5)",
        showLine: false, // No line for the scatter dataset
      },
    ],
  };

  const options = {
    maintainAspectRatio: false, // Allows the chart to resize better
    scales: {
      x: {
        type: "linear",
        position: "bottom",
        ticks: {
          font: {
            size: 9, // Decrease font size of the x-axis labels
            // weight: "bold",
            color: "black",
            zIndex: "99999",
          },
          maxRotation: 60, // Set the maximum rotation for the labels
          minRotation: 60, // Set the minimum rotation for the labels
        },
        title: {
          display: true,
          text: "Median RPM",
          font: {
            // weight: "bold",
            size: 9, // Set the font size for X axis label
            // weight: "bold",
            style: "italic", // Set the font style to italic
          },
          color: "black",
        },
      },
      y: {
        title: {
          display: true,
          text: "Median Throttle",
          font: {
            size: 9, // Set the font size for X axis label
            style: "italic", // Set the font style to italic
          },
          color: "black",
        },
        ticks: {
          font: {
            size: 9, // Decrease font size of the x-axis labels
            // weight: "bold",
            color: "black",
          },
        },
      },
    },
    plugins: {
      legend: {
        display: true,
        labels: {
          filter: function (legendItem, chartData) {
            return (
              legendItem.datasetIndex === 2 || legendItem.datasetIndex === 3
            );
          },
        },
      },
      tooltip: {
        enabled: false,
      },
      datalabels: {
        display: false,
      },
    },
  };

  return (
    <>
      <div className="v-title chartbox drive_graph p-0" style={{ marginBottom: "-14px" }}>
        <div className="titlebg titlebd_drive box_title pb-2 pt-2">{title}</div>
        {/* <div className="mt-4 pt-4" ></div> */}
        <div className="scatterchart mt-4 pt-2 pr-1">
          <Scatter data={data} options={options} height={220} />
        </div>
      </div>
    </>
  );
}

export default RpmVsThrottle_Coral;
